import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './main.css';

import diamond from './images/diamond.svg';
import dots from './images/ Dots.svg';

function Section5() {
    AOS.init();
    return (
        <section className="australia-council-section5-container">
            <div className="ac-section5-paragraph1">
                <div>
                    <img src={diamond} height="80px" alt="diamond" className="ac-section5-image-diamond" />
                    <div className="ac-section5-paragraph1-info-container">
                        <div className="ac-section5-paragraph1-info-container-inner">
                            <div data-aos="fade-right" data-aos-delay="250" data-aos-duration="2000" data-aos-once="true" className="australia-council-section5-numCont"><h2 className="australia-council-section3-num">05</h2></div>
                            <h3 data-aos="fade-down" data-aos-delay="300" data-aos-duration="2000" data-aos-once="true" className="ac-section5-paragraph1-info">Building a sustainable, yet agile system that
                            can play to the strengths of the moment, both
                            in times of COVID and the aftermath</h3></div>
                        <div className="ac-section5-paragraph1-info-container-inner">
                            <img src={dots} height="100px" alt="dots" className="ac-section5-image-dots" />
                            <img src={diamond} height="80px" alt="diamond" className="ac-section5-image-diamond2" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="ac-section5-paragraph2">
                <p className="ac-section5-paragraph2-quote" data-aos="fade-down" data-aos-duration="2000" data-aos-once="true"><i>"Australian respondents are driven to emerging technology because it is seen as essential to business <br />
                    survival they are driven by a desire to improve decision making and customer experience."</i></p>
                <div className="ac-section5-paragraph2-creds-container">
                    <div className="ac-section5-paragraph2-line"></div>
                    <p className="ac-section5-paragraph2-creds" data-aos="fade-down" data-aos-delay="100" data-aos-duration="2000" data-aos-once="true"><i>Jon Stone, Partner, KPMG Digital Delta, quoted in IT Brief Australia (August 21, 2020)</i></p>
                </div>
            </div>
        </section >
    )
}

export default Section5
